import React, { useState } from 'react';
import TechnicalSupportChat from '../components/TechnicalSupportChat';
import '../styles/TechnicalSupportChatView.css';

const TechnicalSupportChatView = () => {
  const [chats, setChats] = useState([{ id: 1, title: 'Chat 1' }]);
  const [activeChat, setActiveChat] = useState(1);

  const getNextId = (currentChats) => {
    const ids = currentChats.map(c => c.id);
    let i = 1;
    while (ids.includes(i)) i++;
    return i;
  };

  const addNewChat = () => {
    setChats(prev => {
      const newId = getNextId(prev);
      const newChat = { id: newId, title: `Chat ${newId}` };
      setActiveChat(newId);
      return [...prev, newChat];
    });
  };

  const closeChat = (chatId) => {
    const updatedChats = chats.filter(chat => chat.id !== chatId);
    if (updatedChats.length === 0) {
      window.history.back();
    } else {
      setChats(updatedChats);
      if (activeChat === chatId) {
        setActiveChat(updatedChats[updatedChats.length - 1].id);
      }
    }
  };

  return (
    <div className="support-chat-view">
      {/* ── Header ── */}
      <div className="support-chat-header">
        {/* Brand */}
        <div className="support-chat-brand">
          <div className="support-chat-brand-icon">
            <i className="fa fa-headphones" />
          </div>
          <div>
            <h4 className="support-chat-brand-title">Soporte Técnico</h4>
            <small className="support-chat-brand-subtitle">Asistente de diagnóstico automático</small>
          </div>
        </div>

        {/* Tabs */}
        <div className="support-chat-tabs">
          {chats.map(chat => (
            <div
              key={chat.id}
              className={`support-chat-tab${activeChat === chat.id ? ' active' : ''}`}
              onClick={() => setActiveChat(chat.id)}
            >
              <i className="fa fa-comments support-chat-tab-icon" />
              <span>{chat.title}</span>
              {chats.length > 1 && (
                <button
                  className="support-chat-tab-close"
                  title="Cerrar chat"
                  onClick={(e) => {
                    e.stopPropagation();
                    closeChat(chat.id);
                  }}
                >
                  ×
                </button>
              )}
            </div>
          ))}
        </div>

        {/* New chat */}
        <button className="support-chat-new-btn" onClick={addNewChat}>
          <i className="fa fa-plus" />
          <span>Nuevo Chat</span>
        </button>
      </div>

      {/* ── Chat panes ── */}
      <div className="support-chat-content">
        {chats.map(chat => (
          <div
            key={chat.id}
            className="support-chat-pane"
            style={{ display: activeChat === chat.id ? 'flex' : 'none' }}
          >
            <TechnicalSupportChat
              isModal={false}
              chatId={chat.id}
              onClose={() => closeChat(chat.id)}
              hideHeader={true}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default TechnicalSupportChatView;

